import type { Locale, Translator } from '@porotutu/i18n'
import { type Column, RowLink } from '@porotutu/react/components/DataTable/DataTable'
import { timestampColumns } from '@porotutu/react/components/DataTable/timestampColumns'
import { StatusBadge } from '@porotutu/react/components/StatusBadge/StatusBadge'
import type { Organization, OrganizationListQuery } from '../queries'

export const columnsFor = (
  t: Translator,
  locale: Locale,
  query: OrganizationListQuery,
): Array<Column<Organization>> => [
  {
    key: 'name',
    header: t('adm.organizations.columns.name'),
    sortKey: 'name',
    cell: (row) => (
      <RowLink to="/organizations/$id" params={{ id: row.id }} search={query}>
        {row.name}
      </RowLink>
    ),
  },
  {
    key: 'slug',
    header: t('adm.organizations.columns.slug'),
    sortKey: 'slug',
    cell: (row) => row.slug,
  },
  {
    key: 'state',
    header: t('adm.organizations.columns.state'),
    cell: (row) => (
      <StatusBadge status={row.enabled ? 'enabled' : 'disabled'} scope="adm.organizations.state" />
    ),
  },
  {
    key: 'members',
    header: t('adm.organizations.columns.members'),
    sortKey: 'members',
    numeric: true,
    cell: (row) => String(row.member_count),
  },
  ...timestampColumns(t, locale),
]
